import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'normalize.css' // 样式重置，保证跨浏览器一致性

// 全局样式
import './assets/css/global.css'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')